import api from './api';
import {ApiResponse} from '../types/common';
import {CreateProxyRuleRequest, ProxyRule, UpdateProxyRuleRequest} from '../types/proxy';

export const proxyRuleService = {
    // 获取所有规则
    getAllRules: async (): Promise<ProxyRule[]> => {
        const response = await api.get<ApiResponse<ProxyRule[]>>('/api/v1/proxy/rules');
        return response.data.data || [];
    },

    // 根据ID获取规则
    getRuleById: async (id: number): Promise<ProxyRule | null> => {
        const response = await api.get<ApiResponse<ProxyRule>>(`/api/v1/proxy/rules/${id}`);
        return response.data.data || null;
    },

    // 获取所有激活的规则
    getActiveRules: async (): Promise<ProxyRule[]> => {
        const response = await api.get<ApiResponse<ProxyRule[]>>('/api/v1/proxy/rules/active');
        return response.data.data || [];
    },

    // 创建规则
    createRule: async (rule: CreateProxyRuleRequest): Promise<ProxyRule | null> => {
        const response = await api.post<ApiResponse<ProxyRule>>('/api/v1/proxy/rules', rule);
        return response.data.data || null;
    },

    // 更新规则
    updateRule: async (id: number, rule: UpdateProxyRuleRequest): Promise<ProxyRule | null> => {
        const response = await api.put<ApiResponse<ProxyRule>>(`/api/v1/proxy/rules/${id}`, rule);
        return response.data.data || null;
    },

    // 删除规则（逻辑删除）
    deleteRule: async (id: number): Promise<boolean> => {
        const response = await api.delete<ApiResponse<void>>(`/api/v1/proxy/rules/${id}`);
        return response.data.code === '0' || false;
    },

    // 更新规则状态
    setRuleStatus: async (id: number, status: 'active' | 'inactive'): Promise<boolean> => {
        const response = await api.put<ApiResponse<void>>(`/api/v1/proxy/rules/${id}/status?status=${status}`);
        return response.data.code === '0' || false;
    },
};